export default __webpack_public_path__ + "static/og-months-08b8eed0df14d1a8b5c3b132a026ff3e.jpg";